import { useQuery } from '@tanstack/react-query';
import { emptyHomeData, homeQuery } from '../../../lib/queries';
import { PostGallerySlider } from '../components/PostGallerySlider';
import { Sidebar } from '../components/Sidebar';
import { HighlightsSection } from '../components/HighlightsSection';
import { NationalSection } from '../components/NationalSection';
import { RegionalsSection } from '../components/RegionalsSection';
import { TvSlider } from '../components/TvSlider';
import { VideoNewsSection } from '../components/VideoNewsSection';
import { AllPostSection } from '../components/AllPostSection';

export function HomePage() {
  const { data } = useQuery({
    ...homeQuery(),
    placeholderData: emptyHomeData,
  });
  const home = data ?? emptyHomeData;

  return (
    <>
      <div className="post__gallery__area pt-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <PostGallerySlider items={home.last24Hours} />
            </div>
            <div className="col-lg-4">
              <Sidebar
                newest={home.sidebar.newest}
                trending={home.sidebar.trending}
                economy={home.sidebar.economy}
              />
            </div>
          </div>
        </div>
      </div>
      <HighlightsSection items={home.highlights} />
      <NationalSection items={home.nationals} />
      <RegionalsSection
        asfis={home.asfis}
        marrakechs={home.marrakechs}
        otherRegions={home.otherRegions}
      />
      <TvSlider items={home.tvArticles} />
      <VideoNewsSection mainHot={home.mainHot} hots={home.hots} />
      <AllPostSection politics={home.politics} sports={home.sports} economy={home.economy} />
    </>
  );
}
